// extracted by mini-css-extract-plugin
module.exports = {"container":"_9400a595a7--container--mGLHS","title":"_9400a595a7--title--LuVj_","link":"_9400a595a7--link--oPguz"};